import { LocationUserAccess } from '@/types';
import { EventContentArg } from '@fullcalendar/core';
import { BackgroundChip } from './Chips/BackgroundChip';
import { BlackoutChip } from './Chips/BlackoutChip';
import { ClockTimeChip } from './Chips/ClockTimeChip';
import { DefaultChip } from './Chips/DefaultChip';
import { EventChip } from './Chips/EventChip';
import { InactiveChip } from './Chips/InactiveChip';
import { LeadChip } from './Chips/LeadChip';
import { NoteChip } from './Chips/NoteChip';
import { ShiftChip } from './Chips/ShiftChip';
import { TaskChip } from './Chips/TaskChip';
import { TravelChip } from './Chips/TravelChip';

type RenderEventContentProps = {
  eventInfo: EventContentArg;
  staff: LocationUserAccess[];
  handleAddStaff: CallableFunction;
};

export const RenderEventContent = ({
  eventInfo,
  staff,
  handleAddStaff,
}: RenderEventContentProps) => {
  const { cal_event_type, activity_id } = eventInfo.event.extendedProps;

  switch (cal_event_type) {
    case 'lead':
      return <LeadChip eventInfo={eventInfo} />;
    case 'event':
      return (
        <EventChip eventInfo={eventInfo} staffOptions={staff} handleAddStaff={handleAddStaff} />
      );
    case 'travel':
      return <TravelChip eventInfo={eventInfo} />;
    case 'blackout':
      return <BlackoutChip eventInfo={eventInfo} />;
    case 'note':
      return <NoteChip eventInfo={eventInfo} />;
    case 'shift':
      return <ShiftChip eventInfo={eventInfo} />;
    case 'clocktime':
      return <ClockTimeChip eventInfo={eventInfo} />;
    case 'background':
      return <BackgroundChip eventInfo={eventInfo} />;
    case 'inactive':
      return <InactiveChip eventInfo={eventInfo} />;
    case 'task':
    case 'maintenance_task':
    case 'inspection':
      return <TaskChip eventInfo={eventInfo} />;
    default:
      return <DefaultChip eventInfo={eventInfo} />;
  }
};
